import { DoubleRangeSlider, Select } from '@benzinga/core-ui';
import { moneynessType, OptionChainFilterProps } from '@benzinga/data-option-chain';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import styles from './OptionChainFilter.module.scss';

const OptionChainFilter = ({
  expiries,
  moneyNess,
  onExpiryChange,
  onMoneynessChange,
  onRangeChange,
  range,
  rangeLimits,
}: OptionChainFilterProps): React.ReactElement => {
  const { t } = useTranslation('quote');

  const meneynessOptions: moneynessType[] = useMemo(
    () => [
      { label: t('Quote.OptionChain.all'), value: 'all' },
      { label: t('Quote.OptionChain.near-the-money'), value: 'near-the-money' },
    ],
    [t],
  );

  return (
    <div className={styles.optionChainRangeFilter}>
      <div className="select-options">
        <Select label="Expiration Date" name="expiration-date" onChange={onExpiryChange}>
          {Array.isArray(expiries) &&
            expiries.map(expiry => (
              <Select.Option key={expiry.value} value={expiry.value}>
                {expiry.label}
              </Select.Option>
            ))}
        </Select>

        <Select
          defaultValue={moneyNess}
          label={t('Quote.OptionChain.moneyness')}
          name="moneyness"
          onChange={onMoneynessChange}
        >
          {meneynessOptions.map(option => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div className="strike-range">
        <DoubleRangeSlider
          label={t('Quote.OptionChain.strike-range')}
          max={rangeLimits?.[1] || 500}
          min={rangeLimits?.[0] || 0}
          onChange={onRangeChange}
          step={5}
          value={range}
        />
      </div>
    </div>
  );
};

export default OptionChainFilter;
